import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { NoResultsFoundIcon } from '@/assets/icons/NoResultsFoundIcon';
import { useDcrFormSearchTerm } from '@/core/store/dcrs/dcrSelectors';

import { noFormFieldsStyles as sx } from './NoFormFields.styles';

export const NoFormFields = () => {
	const { t } = useTranslation();
	const query = useDcrFormSearchTerm();

	return (
		<Box sx={sx.root}>
			<NoResultsFoundIcon sx={sx.searchIcon} />

			<Box sx={sx.selectedFiltersMessage}>
				<Typography
					component='div'
					sx={sx.noResults}
					variant='body1'
					color='text.secondary'
					gutterBottom
				>
					{query ? (
						<>
							{t("No fields found '{{query}}'.", { query })}
							<br />
							{t('Check the spelling, or start a new search.')}
						</>
					) : (
						t('No fields found.')
					)}
				</Typography>
			</Box>
		</Box>
	);
};
